import "./ToggleSwitch.css";

export const ToggleSwitch = ({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: () => void;
  label: string;
}) => {
  return (
    <>
      <label className="switch">
        <input
          type="checkbox"
          aria-label={label}
          checked={checked}
          onChange={onChange}
        />

        <span className="slider round" />
      </label>{" "}
    </>
  );
};
